import gsap from 'gsap'
import * as THREE from 'three'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'

export default class Text {
    constructor(text, scene, font, isReverse = false, groupOffset = 5.2) {
        this.scene = scene
        this.font = font
        this.isReverse = isReverse
        this.groupOffset = groupOffset
        this.radius = 3.9
        this.text = text
        this.textGroup = new THREE.Group()
        this.textMesh = this.generateLorem()
        this.textMesh.renderOrder = 0
        this.textGroup.add(this.textMesh)
        this.scene.add(this.textGroup)
        
    }

    generateLorem() {
        const textContent = this.text
        const textGeometry = new TextGeometry(textContent, {
            font: this.font,
            size: 0.33,
            height: 0.01,
            curveSegments: 12,
            depth: 0.01,
            bevelEnabled: false
        })
        textGeometry.center()
        const vertexShader = `
            uniform float uRadius;
            uniform float uReverse;
            void main() {
                vec3 pos = position;
                float theta = pos.x / uRadius;
                float sinTheta = sin(theta);
                float cosTheta = cos(theta);
                pos.x = uRadius * sinTheta;
                pos.y = pos.y + uRadius * (1.0 - cosTheta) * uReverse ;
                gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
            }
        `

        const fragmentShader = `
            uniform float uAlpha;

            void main() {
                gl_FragColor = vec4(vec3(1.0), uAlpha);
            }
        `

        const shaderMaterial = new THREE.ShaderMaterial({
            uniforms: {
                uRadius: { value: this.radius },
                uReverse: { value: this.isReverse ? -1.0 : 1.0 },
                uAlpha: { value: 0.0 }
            },
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            transparent: false,
            blending: THREE.AdditiveBlending,
        })

        const textMesh = new THREE.Mesh(textGeometry, shaderMaterial)
        return textMesh
    }
    show() {
        gsap.to(this.textMesh.material.uniforms.uAlpha, {
            value: 1.0,
            duration: 2.0,
            ease: 'circ.in',
        })
    }

    clone() {
        return this.textMesh.clone()
    }

    update() {
    }
}
